export function normalizeSocialUsername(username: string) {
  const match = username.match(
    /(?:https?:\/\/)?(?:www\.)?(instagram\.com|twitter\.com|x\.com)\/([^/?#]+)(?:[/?#]|$)/i,
  );
  if (match && match[2]) {
    return match[2];
  }

  if (username.startsWith('@')) {
    return username.substring(1);
  }

  return username;
}
